export enum LanguageEnum {
    English = 1,
    French
}
